enum HttpStatus {
  Created = 201,
  Success = 200,
  Deleted = 406,
}
export default HttpStatus;
